import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { WorkoutResult } from 'types';
import { client } from 'utils/api-client';

import { SetSectionLevelInput } from './useSetSectionLevel';

// Coach-on-behalf: bulk-sets any athlete's level for a section. Hits
// `workout-results/section-level/`, gated server-side by ["owner", "staff"].
export type SetSectionLevelAsStaffInput = SetSectionLevelInput & { athlete: string };

function useSetSectionLevelAsStaff(
  workoutId: string | undefined,
): UseMutationResult<AxiosResponse<WorkoutResult[]>, AxiosError, SetSectionLevelAsStaffInput> {
  const queryClient = useQueryClient();
  return useMutation(
    (input: SetSectionLevelAsStaffInput) =>
      client.patch<WorkoutResult[]>('workout-results/section-level/', input),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['workout-athlete-results', workoutId]);
        queryClient.invalidateQueries(['workout-leaderboard', workoutId]);
      },
    },
  );
}

export default useSetSectionLevelAsStaff;
